export default "/images/e114cc1fc78e40ced6fa4530a8c74164.jpg";